import React from 'react';
import { Link } from 'react-router-dom';
import './KirikanWallpaperBanner.css';

export default function KirikanWallpaperBanner() {
  return (
    <Link to="/kirikan-materials" className="kirikan-wallpaper-banner">
      <img src="/static/images/kirikan-wallpapers/chapel-pc.jpg" alt="" width="960" height="540" loading="lazy" />
      <span className="kirikan-wallpaper-banner__copy">
        <span className="kirikan-wallpaper-banner__label">FREE WALLPAPERS</span>
        <strong>キリ看ちゃん<br />フリー素材</strong>
        <span>PC・スマホの壁紙、各3種類。</span>
        <span className="kirikan-wallpaper-banner__cta">無料ダウンロード →</span>
      </span>
    </Link>
  );
}
